import { useState } from "react";

export function useAsyncAction<T>() {
  const [isPending, setIsLoading] = useState(false);

  const execute = async (asyncFunction: () => Promise<T>) => {
    if (isPending) return;

    setIsLoading(true);
    try {
      await asyncFunction();
    } finally {
      setIsLoading(false);
    }
  };

  return { isPending, execute };
}
